import { Color } from 'ng2-charts/lib/color';
import { ajaxGet } from 'rxjs/internal-compatibility';

export const CropSizes = {
    field: { first: 1384, sec: 593 },
    feed: { first: 1307, sec: 692 },
    popup: { first: 1334, sec: 980 }
};


export const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

export const EGYPT_COUNTRYID = '5dcf9c7ac26ed6285f55315d'; //TEST_SERVER_EGYPT_COUNTRYID
//export const EGYPT_COUNTRYID = '5c8d4dfa72b7100fe06eb568'; //LIVE_SERVER_EGYPT_COUNTRYID

export const ARABIC = '[\u0600-\u06FF]';
// export const ARABIC = '[أ-ي]';
// export const ARABIC = '^[\p{Arabic}\s\p{N}]+$';
export const ENGLISH = '^[a-zA-Z ]+$';

export const AgeGroup = [{ name: 'U 13', value: '13', isSelected: false },
{ name: 'U 14', value: '14', isSelected: false },
{ name: 'U 15', value: '15', isSelected: false },
{ name: 'U 16', value: '16', isSelected: false },
{ name: 'U 17', value: '17', isSelected: false },
{ name: 'U 18', value: '18', isSelected: false },
{ name: 'U 19', value: '19', isSelected: false },
{ name: 'U 20', value: '20', isSelected: false },
{ name: '20 - 24', value: '2024', isSelected: false },
{ name: '24+ (senior)', value: '24', isSelected: false }
];

export const AgeGroup2 = [{ name: 'U 13', value: '13', isSelected: false },
{ name: 'U 14', value: '14', isSelected: false },
{ name: 'U 15', value: '15', isSelected: false },
{ name: 'U 16', value: '16', isSelected: false },
{ name: 'U 17', value: '17', isSelected: false },
{ name: 'U 18', value: '18', isSelected: false },
{ name: 'U 19', value: '19', isSelected: false },
{ name: 'U 20', value: '20', isSelected: false },
{ name: '20+', value: '2024', isSelected: false },
{ name: '24+', value: '24', isSelected: false }
];

export const sideBarAdmin = [

     {
         path: '/dashboard',
        icon: '/assets/images/ic_home.svg',
        children: [],
        title: 'SIDEBAR.HOME',
        permissions: ['dashboard', 'players']
     },
     {
        path: 'players-dashboard',
        icon: '/assets/images/icons/ic_dashboard.svg',
        children: [],
        title: 'SIDEBAR.DASHBOARD',
        permissions: ['dashboard', 'players']
    },
    {
        path: 'players',
        icon: '/assets/images/icons/ic_players.svg',
        children: [], 
        title: 'SIDEBAR.PLAYERS',
        permissions: ['dashboard', 'players']
    },
    {
        path: 'try-out',
        icon: '/assets/images/icons/ic_tryouts.svg',
        children: [], 
        title: 'SIDEBAR.TRYOUTS',
        permissions: ['dashboard', 'players']
    },
    {
        path: 'elite',
        icon: '/assets/images/icons/ic_elite.svg',
        children: [], 
        title: 'SIDEBAR.THE_ELITE',
        permissions: ['dashboard', 'players']
    },
    {
        path: 'ranking',
        icon: '/assets/images/icons/ic_top_ranking.svg',
        children: [], 
        title: 'SIDEBAR.TOP_RANKING',
        permissions: ['dashboard', 'players']
    },   
  
    {
        path: 'feeds',
        icon: '/assets/images/icons/ic_feeds.svg',
        children: [], 
        title: 'SIDEBAR.FEEDS',
        permissions: ['dashboard', 'players']
    } 
];

export const sideBarStaff = [
    { path: '/dashboard', icon: 'fa fa-th-large', children: [], title: 'Dashboard' },
    {
        path: 'bookings', icon: 'fas fa-calendar-week', title: 'Bookings', children: [
            { path: '/booking-details', icon: '', children: [], title: 'Booking Details' },
            { path: '/booking-summary', icon: '', children: [], title: 'Booking Summary' }
        ]
    },
    {
        path: 'owners', icon: 'fa fa-flag', title: 'Owner Data', children: [
            { path: '/fields', icon: '', children: [], title: 'Field List' },
            { path: '/owners', icon: '', children: [], title: 'Owner List' },
            { path: '/contracts', icon: '', children: [], title: 'Contract List' }
        ]
    }
];




export const sideBarBroadcast = [


    { path: '/broadcast', icon: 'fas fa-broadcast-tower', children: [], title: 'Broadcast' }
];

export const sideBarEmployee = [
    {
        path: 'players', icon: 'fa fa-users', title: 'Players data', children: [
            { path: '/posts', icon: '', children: [], title: 'Posts' }
        ]
    },
    { path: '/broadcast', icon: 'fas fa-broadcast-tower', children: [], title: 'Broadcast' },
    { path: '/sponsors', icon: 'fa fa-credit-card', title: 'Sponsors', children: [] },
    { path: '/advertisements', icon: 'fa fa-audio-description', children: [], title: 'Advertisements' }
];

export const GraphColors = [
    { // red
        backgroundColor: 'transparent',
        borderColor: 'red',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }, { // dark grey
        backgroundColor: 'transparent',
        borderColor: 'rgba(248,172,89,1)',
        pointBackgroundColor: 'rgba(248,172,89,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(248,172,89,1)'
    
    }

];
export const GraphColorsV2 = [
    { // red
        backgroundColor: 'transparent',
        borderColor: 'red',
        pointBackgroundColor: 'red',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }, { // dark grey
        backgroundColor: 'transparent',
        borderColor: 'rgba(248,172,89,1)',
        pointBackgroundColor: 'rgba(248,172,89,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(248,172,89,1)'
    
    }

];
export const DonutGraphColors = [
    { // red
        backgroundColor: 'rgba(255,0,0,0.3)',
        borderColor: 'red',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }

];

export const BarGraphColors = [
    { // blue
        backgroundColor: 'rgba(66,201,90,0.2)', //rgba(76,198,200,0.5)
        borderColor: '#d80019',
        pointBackgroundColor: '#d80019',
        pointBorderColor: '#d80019',
        pointHoverBackgroundColor: '#d80019',
        pointHoverBorderColor: '#d80019'
    },

];
export const Monts = [
    {
        name:"January",
        sortName:"Jan",
        id:1,
        isSelected : false
    },
    {
        name:"February",
        sortName:"Feb",
        id:2,
        isSelected : false
    },
    {
        name:"March",
        sortName:"Mar",
        id:3,
        isSelected : false
    },
    {
        name:"April",
        sortName:"Apr",
        id:4,
        isSelected : false
    },
    {
        name:"May",
        sortName:"May",
        id:5,
        isSelected : false
    },
    {
        name:"June",
        sortName:"Jun",
        id:6,
        isSelected : false
    },
    {
        name:"July",
        sortName:"Jul",
        id:7,
        isSelected : false
    },
    {
        name:"August",
        sortName:"Aug",
        id:8,
        isSelected : false
    },
    {
        name:"September",
        sortName:"Sep",
        id:9,
        isSelected : false
    },
    {
        name:"October",
        sortName:"Oct",
        id:10,
        isSelected : false
    },
    {
        name:"November",
        sortName:"Nov",
        id:11,
        isSelected : false
    },
    {
        name:"December",
        sortName:"Dec",
        id:12,
        isSelected : false
    }
]


export const countryNames =[
    {
      "code": "AF",
      "emoji": "🇦🇫",
      "unicode": "U+1F1E6 U+1F1EB",
      "name": "Afghanistan",
      "title": "flag for Afghanistan",
      "name_ar": "أفغانستان"
    },
    {
      "code": "AX",
      "emoji": "🇦🇽",
      "unicode": "U+1F1E6 U+1F1FD",
      "name": "Aland Islands",
      "title": "flag for Åland Islands",
      "name_ar": "جزر آلاند"
    },
    {
      "code": "AL",
      "emoji": "🇦🇱",
      "unicode": "U+1F1E6 U+1F1F1",
      "name": "Albania",
      "title": "flag for Albania",
      "name_ar": "ألبانيا"
    },
    {
      "code": "DZ",
      "emoji": "🇩🇿",
      "unicode": "U+1F1E9 U+1F1FF",
      "name": "Algeria",
      "title": "flag for Algeria",
      "name_ar": "الجزائر"
    },
    {
      "code": "AS",
      "emoji": "🇦🇸",
      "unicode": "U+1F1E6 U+1F1F8",
      "name": "American Samoa",
      "title": "flag for American Samoa",
      "name_ar": "ساموا الأمريكية"
    },
    {
      "code": "AD",
      "emoji": "🇦🇩",
      "unicode": "U+1F1E6 U+1F1E9",
      "name": "Andorra",
      "title": "flag for Andorra",
      "name_ar": "أندورا"
    },
    {
      "code": "AO",
      "emoji": "🇦🇴",
      "unicode": "U+1F1E6 U+1F1F4",
      "name": "Angola",
      "title": "flag for Angola",
      "name_ar": "أنغولا"
    },
    {
      "code": "AI",
      "emoji": "🇦🇮",
      "unicode": "U+1F1E6 U+1F1EE",
      "name": "Anguilla",
      "title": "flag for Anguilla",
      "name_ar": "أنغيلا"
    },
    {
      "code": "AQ",
      "emoji": "🇦🇶",
      "unicode": "U+1F1E6 U+1F1F6",
      "name": "Antarctica",
      "title": "flag for Antarctica",
      "name_ar": "القارة القطبية الجنوبية"
    },
    {
      "code": "AG",
      "emoji": "🇦🇬",
      "unicode": "U+1F1E6 U+1F1EC",
      "name": "Antigua and Barbuda",
      "title": "flag for Antigua and Barbuda",
      "name_ar": "أنتيغوا وبربودا"
    },
    {
      "code": "AR",
      "emoji": "🇦🇷",
      "unicode": "U+1F1E6 U+1F1F7",
      "name": "Argentina",
      "title": "flag for Argentina",
      "name_ar": "الأرجنتين"
    },
    {
      "code": "AM",
      "emoji": "🇦🇲",
      "unicode": "U+1F1E6 U+1F1F2",
      "name": "Armenia",
      "title": "flag for Armenia",
      "name_ar": "أرمينيا"
    },
    {
      "code": "AW",
      "emoji": "🇦🇼",
      "unicode": "U+1F1E6 U+1F1FC",
      "name": "Aruba",
      "title": "flag for Aruba",
      "name_ar": "أروبا"
    },
    {
      "code": "AU",
      "emoji": "🇦🇺",
      "unicode": "U+1F1E6 U+1F1FA",
      "name": "Australia",
      "title": "flag for Australia",
      "name_ar": "أستراليا"
    },
    {
      "code": "AT",
      "emoji": "🇦🇹",
      "unicode": "U+1F1E6 U+1F1F9",
      "name": "Austria",
      "title": "flag for Austria",
      "name_ar": "النمسا"
    },
    {
      "code": "AZ",
      "emoji": "🇦🇿",
      "unicode": "U+1F1E6 U+1F1FF",
      "name": "Azerbaijan",
      "title": "flag for Azerbaijan",
      "name_ar": "أذربيجان"
    },
    {
      "code": "BS",
      "emoji": "🇧🇸",
      "unicode": "U+1F1E7 U+1F1F8",
      "name": "Bahamas",
      "title": "flag for Bahamas",
      "name_ar": "الباهاما"
    },
    {
      "code": "BH",
      "emoji": "🇧🇭",
      "unicode": "U+1F1E7 U+1F1ED",
      "name": "Bahrain",
      "title": "flag for Bahrain",
      "name_ar": "البحرين"
    },
    {
      "code": "BD",
      "emoji": "🇧🇩",
      "unicode": "U+1F1E7 U+1F1E9",
      "name": "Bangladesh",
      "title": "flag for Bangladesh",
      "name_ar": "بنغلاديش"
    },
    {
      "code": "BB",
      "emoji": "🇧🇧",
      "unicode": "U+1F1E7 U+1F1E7",
      "name": "Barbados",
      "title": "flag for Barbados",
      "name_ar": "بربادوس"
    },
    {
      "code": "BY",
      "emoji": "🇧🇾",
      "unicode": "U+1F1E7 U+1F1FE",
      "name": "Belarus",
      "title": "flag for Belarus",
      "name_ar": "روسيا البيضاء"
    },
    {
      "code": "BE",
      "emoji": "🇧🇪",
      "unicode": "U+1F1E7 U+1F1EA",
      "name": "Belgium",
      "title": "flag for Belgium",
      "name_ar": "بلجيكا"
    },
    {
      "code": "BZ",
      "emoji": "🇧🇿",
      "unicode": "U+1F1E7 U+1F1FF",
      "name": "Belize",
      "title": "flag for Belize",
      "name_ar": "بليز"
    },
    {
      "code": "BJ",
      "emoji": "🇧🇯",
      "unicode": "U+1F1E7 U+1F1EF",
      "name": "Benin",
      "title": "flag for Benin",
      "name_ar": "بنين"
    },
    {
      "code": "BM",
      "emoji": "🇧🇲",
      "unicode": "U+1F1E7 U+1F1F2",
      "name": "Bermuda",
      "title": "flag for Bermuda",
      "name_ar": "برمودا"
    },
    {
      "code": "BT",
      "emoji": "🇧🇹",
      "unicode": "U+1F1E7 U+1F1F9",
      "name": "Bhutan",
      "title": "flag for Bhutan",
      "name_ar": "بوتان"
    },
    {
      "code": "BO",
      "emoji": "🇧🇴",
      "unicode": "U+1F1E7 U+1F1F4",
      "name": "Bolivia",
      "title": "flag for Bolivia",
      "name_ar": "بوليفيا"
    },
    {
      "code": "BA",
      "emoji": "🇧🇦",
      "unicode": "U+1F1E7 U+1F1E6",
      "name": "Bosnia and Herzegovina",
      "title": "flag for Bosnia and Herzegovina",
      "name_ar": "البوسنة و الهرسك"
    },
    {
      "code": "BW",
      "emoji": "🇧🇼",
      "unicode": "U+1F1E7 U+1F1FC",
      "name": "Botswana",
      "title": "flag for Botswana",
      "name_ar": "بوتسوانا"
    },
    {
      "code": "BR",
      "emoji": "🇧🇷",
      "unicode": "U+1F1E7 U+1F1F7",
      "name": "Brazil",
      "title": "flag for Brazil",
      "name_ar": "البرازيل"
    },
    {
      "code": "IO",
      "emoji": "🇮🇴",
      "unicode": "U+1F1EE U+1F1F4",
      "name": "British Indian Ocean Territory",
      "title": "flag for British Indian Ocean Territory",
      "name_ar": "إقليم المحيط البريطاني الهندي"
    },
    {
      "code": "BN",
      "emoji": "🇧🇳",
      "unicode": "U+1F1E7 U+1F1F3",
      "name": "Brunei Darussalam",
      "title": "flag for Brunei Darussalam",
      "name_ar": "بروناي"
    },
    {
      "code": "BG",
      "emoji": "🇧🇬",
      "unicode": "U+1F1E7 U+1F1EC",
      "name": "Bulgaria",
      "title": "flag for Bulgaria",
      "name_ar": "بلغاريا"
    },
    {
      "code": "BF",
      "emoji": "🇧🇫",
      "unicode": "U+1F1E7 U+1F1EB",
      "name": "Burkina Faso",
      "title": "flag for Burkina Faso",
      "name_ar": "بوركينا فاسو"
    },
    {
      "code": "BI",
      "emoji": "🇧🇮",
      "unicode": "U+1F1E7 U+1F1EE",
      "name": "Burundi",
      "title": "flag for Burundi",
      "name_ar": "بوروندي"
    },
    {
      "code": "KH",
      "emoji": "🇰🇭",
      "unicode": "U+1F1F0 U+1F1ED",
      "name": "Cambodia",
      "title": "flag for Cambodia",
      "name_ar": "كمبوديا"
    },
    {
      "code": "CM",
      "emoji": "🇨🇲",
      "unicode": "U+1F1E8 U+1F1F2",
      "name": "Cameroon",
      "title": "flag for Cameroon",
      "name_ar": "الكاميرون"
    },
    {
      "code": "CA",
      "emoji": "🇨🇦",
      "unicode": "U+1F1E8 U+1F1E6",
      "name": "Canada",
      "title": "flag for Canada",
      "name_ar": "كندا"
    },
    {
      "code": "CV",
      "emoji": "🇨🇻",
      "unicode": "U+1F1E8 U+1F1FB",
      "name": "Cape Verde",
      "title": "flag for Cape Verde",
      "name_ar": "الرأس الأخضر"
    },
    {
      "code": "KY",
      "emoji": "🇰🇾",
      "unicode": "U+1F1F0 U+1F1FE",
      "name": "Cayman Islands",
      "title": "flag for Cayman Islands",
      "name_ar": "جزر كايمان"
    },
    {
      "code": "CF",
      "emoji": "🇨🇫",
      "unicode": "U+1F1E8 U+1F1EB",
      "name": "Central African Republic",
      "title": "flag for Central African Republic",
      "name_ar": "جمهورية افريقيا الوسطى"
    },
    {
      "code": "TD",
      "emoji": "🇹🇩",
      "unicode": "U+1F1F9 U+1F1E9",
      "name": "Chad",
      "title": "flag for Chad",
      "name_ar": "تشاد"
    },
    {
      "code": "CL",
      "emoji": "🇨🇱",
      "unicode": "U+1F1E8 U+1F1F1",
      "name": "Chile",
      "title": "flag for Chile",
      "name_ar": "تشيلي"
    },
    {
      "code": "CN",
      "emoji": "🇨🇳",
      "unicode": "U+1F1E8 U+1F1F3",
      "name": "China",
      "title": "flag for China",
      "name_ar": "جمهورية الصين الشعبية"
    },
    {
      "code": "CX",
      "emoji": "🇨🇽",
      "unicode": "U+1F1E8 U+1F1FD",
      "name": "Christmas Island",
      "title": "flag for Christmas Island",
      "name_ar": "جزيرة الكريسماس"
    },
    {
      "code": "CC",
      "emoji": "🇨🇨",
      "unicode": "U+1F1E8 U+1F1E8",
      "name": "Cocos (Keeling) Islands",
      "title": "flag for Cocos (Keeling) Islands",
      "name_ar": "جزر كوكوس (كيلينغ)"
    },
    {
      "code": "CO",
      "emoji": "🇨🇴",
      "unicode": "U+1F1E8 U+1F1F4",
      "name": "Colombia",
      "title": "flag for Colombia",
      "name_ar": "كولومبيا"
    },
    {
      "code": "KM",
      "emoji": "🇰🇲",
      "unicode": "U+1F1F0 U+1F1F2",
      "name": "Comoros",
      "title": "flag for Comoros",
      "name_ar": "جزر القمر"
    },
    {
      "code": "CD",
      "emoji": "🇨🇩",
      "unicode": "U+1F1E8 U+1F1E9",
      "name": "Congo",
      "title": "flag for Congo",
      "name_ar": "الكونغو"
    },
    {
      "code": "CG",
      "emoji": "🇨🇬",
      "unicode": "U+1F1E8 U+1F1EC",
      "name": "Congo",
      "title": "flag for Congo",
      "name_ar": "الكونغو"
    },
    {
      "code": "CK",
      "emoji": "🇨🇰",
      "unicode": "U+1F1E8 U+1F1F0",
      "name": "Cook Islands",
      "title": "flag for Cook Islands",
      "name_ar": "جزر كوك"
    },
    {
      "code": "CR",
      "emoji": "🇨🇷",
      "unicode": "U+1F1E8 U+1F1F7",
      "name": "Costa Rica",
      "title": "flag for Costa Rica",
      "name_ar": "كوستا ريكا"
    },
    {
      "code": "HR",
      "emoji": "🇭🇷",
      "unicode": "U+1F1ED U+1F1F7",
      "name": "Croatia",
      "title": "flag for Croatia",
      "name_ar": "كرواتيا"
    },
    {
      "code": "CU",
      "emoji": "🇨🇺",
      "unicode": "U+1F1E8 U+1F1FA",
      "name": "Cuba",
      "title": "flag for Cuba",
      "name_ar": "كوبا"
    },
    {
      "code": "CY",
      "emoji": "🇨🇾",
      "unicode": "U+1F1E8 U+1F1FE",
      "name": "Cyprus",
      "title": "flag for Cyprus",
      "name_ar": "قبرص"
    },
    {
      "code": "CZ",
      "emoji": "🇨🇿",
      "unicode": "U+1F1E8 U+1F1FF",
      "name": "Czech Republic",
      "title": "flag for Czech Republic",
      "name_ar": "الجمهورية التشيكية"
    },
    {
      "code": "CI",
      "emoji": "🇨🇮",
      "unicode": "U+1F1E8 U+1F1EE",
      "name": "Côte D'Ivoire",
      "title": "flag for Côte D'Ivoire",
      "name_ar": "كوت ديفوار"
    },
    {
      "code": "DK",
      "emoji": "🇩🇰",
      "unicode": "U+1F1E9 U+1F1F0",
      "name": "Denmark",
      "title": "flag for Denmark",
      "name_ar": "الدانمارك"
    },
    {
      "code": "DJ",
      "emoji": "🇩🇯",
      "unicode": "U+1F1E9 U+1F1EF",
      "name": "Djibouti",
      "title": "flag for Djibouti",
      "name_ar": "جيبوتي"
    },
    {
      "code": "DM",
      "emoji": "🇩🇲",
      "unicode": "U+1F1E9 U+1F1F2",
      "name": "Dominica",
      "title": "flag for Dominica",
      "name_ar": "دومينيكا"
    },
    {
      "code": "DO",
      "emoji": "🇩🇴",
      "unicode": "U+1F1E9 U+1F1F4",
      "name": "Dominican Republic",
      "title": "flag for Dominican Republic",
      "name_ar": "جمهورية الدومنيكان"
    },
    {
      "code": "EC",
      "emoji": "🇪🇨",
      "unicode": "U+1F1EA U+1F1E8",
      "name": "Ecuador",
      "title": "flag for Ecuador",
      "name_ar": "الإكوادور"
    },
    {
      "code": "EG",
      "emoji": "🇪🇬",
      "unicode": "U+1F1EA U+1F1EC",
      "name": "Egypt",
      "title": "flag for Egypt",
      "name_ar": "مصر"
    },
    {
      "code": "SV",
      "emoji": "🇸🇻",
      "unicode": "U+1F1F8 U+1F1FB",
      "name": "El Salvador",
      "title": "flag for El Salvador",
      "name_ar": "السلفادور"
    },
    {
      "code": "GQ",
      "emoji": "🇬🇶",
      "unicode": "U+1F1EC U+1F1F6",
      "name": "Equatorial Guinea",
      "title": "flag for Equatorial Guinea",
      "name_ar": "غينيا الإستوائية"
    },
    {
      "code": "ER",
      "emoji": "🇪🇷",
      "unicode": "U+1F1EA U+1F1F7",
      "name": "Eritrea",
      "title": "flag for Eritrea",
      "name_ar": "إريتريا"
    },
    {
      "code": "EE",
      "emoji": "🇪🇪",
      "unicode": "U+1F1EA U+1F1EA",
      "name": "Estonia",
      "title": "flag for Estonia",
      "name_ar": "استونيا"
    },
    {
      "code": "ET",
      "emoji": "🇪🇹",
      "unicode": "U+1F1EA U+1F1F9",
      "name": "Ethiopia",
      "title": "flag for Ethiopia",
      "name_ar": "أثيوبيا"
    },
    {
      "code": "FK",
      "emoji": "🇫🇰",
      "unicode": "U+1F1EB U+1F1F0",
      "name": "Falkland Islands (Malvinas)",
      "title": "flag for Falkland Islands (Malvinas)",
      "name_ar": "جزر فوكلاند (مالفيناس)"
    },
    {
      "code": "FO",
      "emoji": "🇫🇴",
      "unicode": "U+1F1EB U+1F1F4",
      "name": "Faroe Islands",
      "title": "flag for Faroe Islands",
      "name_ar": "جزر صناعية"
    },
    {
      "code": "FJ",
      "emoji": "🇫🇯",
      "unicode": "U+1F1EB U+1F1EF",
      "name": "Fiji",
      "title": "flag for Fiji",
      "name_ar": "فيجي"
    },
    {
      "code": "FI",
      "emoji": "🇫🇮",
      "unicode": "U+1F1EB U+1F1EE",
      "name": "Finland",
      "title": "flag for Finland",
      "name_ar": "فنلندا"
    },
    {
      "code": "FR",
      "emoji": "🇫🇷",
      "unicode": "U+1F1EB U+1F1F7",
      "name": "France",
      "title": "flag for France",
      "name_ar": "فرنسا"
    },
    {
      "code": "GF",
      "emoji": "🇬🇫",
      "unicode": "U+1F1EC U+1F1EB",
      "name": "French Guiana",
      "title": "flag for French Guiana",
      "name_ar": "غيانا الفرنسية"
    },
    {
      "code": "PF",
      "emoji": "🇵🇫",
      "unicode": "U+1F1F5 U+1F1EB",
      "name": "French Polynesia",
      "title": "flag for French Polynesia",
      "name_ar": "بولينيزيا الفرنسية"
    },
    {
      "code": "GA",
      "emoji": "🇬🇦",
      "unicode": "U+1F1EC U+1F1E6",
      "name": "Gabon",
      "title": "flag for Gabon",
      "name_ar": "الغابون"
    },
    {
      "code": "GM",
      "emoji": "🇬🇲",
      "unicode": "U+1F1EC U+1F1F2",
      "name": "Gambia",
      "title": "flag for Gambia",
      "name_ar": "غامبيا"
    },
    {
      "code": "GE",
      "emoji": "🇬🇪",
      "unicode": "U+1F1EC U+1F1EA",
      "name": "Georgia",
      "title": "flag for Georgia",
      "name_ar": "جيورجيا"
    },
    {
      "code": "DE",
      "emoji": "🇩🇪",
      "unicode": "U+1F1E9 U+1F1EA",
      "name": "Germany",
      "title": "flag for Germany",
      "name_ar": "ألمانيا"
    },
    {
      "code": "GH",
      "emoji": "🇬🇭",
      "unicode": "U+1F1EC U+1F1ED",
      "name": "Ghana",
      "title": "flag for Ghana",
      "name_ar": "غانا"
    },
    {
      "code": "GI",
      "emoji": "🇬🇮",
      "unicode": "U+1F1EC U+1F1EE",
      "name": "Gibraltar",
      "title": "flag for Gibraltar",
      "name_ar": "جبل طارق"
    },
    {
      "code": "GR",
      "emoji": "🇬🇷",
      "unicode": "U+1F1EC U+1F1F7",
      "name": "Greece",
      "title": "flag for Greece",
      "name_ar": "اليونان"
    },
    {
      "code": "GL",
      "emoji": "🇬🇱",
      "unicode": "U+1F1EC U+1F1F1",
      "name": "Greenland",
      "title": "flag for Greenland",
      "name_ar": "الأرض الخضراء"
    },
    {
      "code": "GD",
      "emoji": "🇬🇩",
      "unicode": "U+1F1EC U+1F1E9",
      "name": "Grenada",
      "title": "flag for Grenada",
      "name_ar": "غرينادا"
    },
    {
      "code": "GP",
      "emoji": "🇬🇵",
      "unicode": "U+1F1EC U+1F1F5",
      "name": "Guadeloupe",
      "title": "flag for Guadeloupe",
      "name_ar": "جوادلوب"
    },
    {
      "code": "GU",
      "emoji": "🇬🇺",
      "unicode": "U+1F1EC U+1F1FA",
      "name": "Guam",
      "title": "flag for Guam",
      "name_ar": "غوام"
    },
    {
      "code": "GT",
      "emoji": "🇬🇹",
      "unicode": "U+1F1EC U+1F1F9",
      "name": "Guatemala",
      "title": "flag for Guatemala",
      "name_ar": "غواتيمالا"
    },
    {
      "code": "GG",
      "emoji": "🇬🇬",
      "unicode": "U+1F1EC U+1F1EC",
      "name": "Guernsey",
      "title": "flag for Guernsey",
      "name_ar": "غيرنسي"
    },
    {
      "code": "GN",
      "emoji": "🇬🇳",
      "unicode": "U+1F1EC U+1F1F3",
      "name": "Guinea",
      "title": "flag for Guinea",
      "name_ar": "غينيا"
    },
    {
      "code": "GW",
      "emoji": "🇬🇼",
      "unicode": "U+1F1EC U+1F1FC",
      "name": "Guinea-Bissau",
      "title": "flag for Guinea-Bissau",
      "name_ar": "غينيا بيساو"
    },
    {
      "code": "GY",
      "emoji": "🇬🇾",
      "unicode": "U+1F1EC U+1F1FE",
      "name": "Guyana",
      "title": "flag for Guyana",
      "name_ar": "غيانا"
    },
    {
      "code": "HT",
      "emoji": "🇭🇹",
      "unicode": "U+1F1ED U+1F1F9",
      "name": "Haiti",
      "title": "flag for Haiti",
      "name_ar": "هايتي"
    },
    {
      "code": "HN",
      "emoji": "🇭🇳",
      "unicode": "U+1F1ED U+1F1F3",
      "name": "Honduras",
      "title": "flag for Honduras",
      "name_ar": "هندوراس"
    },
    {
      "code": "HK",
      "emoji": "🇭🇰",
      "unicode": "U+1F1ED U+1F1F0",
      "name": "Hong Kong",
      "title": "flag for Hong Kong",
      "name_ar": "هونغ كونغ"
    },
    {
      "code": "HU",
      "emoji": "🇭🇺",
      "unicode": "U+1F1ED U+1F1FA",
      "name": "Hungary",
      "title": "flag for Hungary",
      "name_ar": "المجر"
    },
    {
      "code": "IS",
      "emoji": "🇮🇸",
      "unicode": "U+1F1EE U+1F1F8",
      "name": "Iceland",
      "title": "flag for Iceland",
      "name_ar": "آيسلندا"
    },
    {
      "code": "IN",
      "emoji": "🇮🇳",
      "unicode": "U+1F1EE U+1F1F3",
      "name": "India",
      "title": "flag for India",
      "name_ar": "الهند"
    },
    {
      "code": "ID",
      "emoji": "🇮🇩",
      "unicode": "U+1F1EE U+1F1E9",
      "name": "Indonesia",
      "title": "flag for Indonesia",
      "name_ar": "أندونيسيا"
    },
    {
      "code": "IR",
      "emoji": "🇮🇷",
      "unicode": "U+1F1EE U+1F1F7",
      "name": "Iran",
      "title": "flag for Iran",
      "name_ar": "إيران"
    },
    {
      "code": "IQ",
      "emoji": "🇮🇶",
      "unicode": "U+1F1EE U+1F1F6",
      "name": "Iraq",
      "title": "flag for Iraq",
      "name_ar": "العراق"
    },
    {
      "code": "IE",
      "emoji": "🇮🇪",
      "unicode": "U+1F1EE U+1F1EA",
      "name": "Ireland",
      "title": "flag for Ireland",
      "name_ar": "جمهورية أيرلندا"
    },
    {
      "code": "IT",
      "emoji": "🇮🇹",
      "unicode": "U+1F1EE U+1F1F9",
      "name": "Italy",
      "title": "flag for Italy",
      "name_ar": "إيطاليا"
    },
    {
      "code": "JM",
      "emoji": "🇯🇲",
      "unicode": "U+1F1EF U+1F1F2",
      "name": "Jamaica",
      "title": "flag for Jamaica",
      "name_ar": "جامايكا"
    },
    {
      "code": "JP",
      "emoji": "🇯🇵",
      "unicode": "U+1F1EF U+1F1F5",
      "name": "Japan",
      "title": "flag for Japan",
      "name_ar": "اليابان"
    },
    {
      "code": "JE",
      "emoji": "🇯🇪",
      "unicode": "U+1F1EF U+1F1EA",
      "name": "Jersey",
      "title": "flag for Jersey",
      "name_ar": "جيرسي"
    },
    {
      "code": "JO",
      "emoji": "🇯🇴",
      "unicode": "U+1F1EF U+1F1F4",
      "name": "Jordan",
      "title": "flag for Jordan",
      "name_ar": "الأردن"
    },
    {
      "code": "KZ",
      "emoji": "🇰🇿",
      "unicode": "U+1F1F0 U+1F1FF",
      "name": "Kazakhstan",
      "title": "flag for Kazakhstan",
      "name_ar": "كازاخستان"
    },
    {
      "code": "KE",
      "emoji": "🇰🇪",
      "unicode": "U+1F1F0 U+1F1EA",
      "name": "Kenya",
      "title": "flag for Kenya",
      "name_ar": "كينيا"
    },
    {
      "code": "KI",
      "emoji": "🇰🇮",
      "unicode": "U+1F1F0 U+1F1EE",
      "name": "Kiribati",
      "title": "flag for Kiribati",
      "name_ar": "كيريباس"
    },
    {
      "code": "KW",
      "emoji": "🇰🇼",
      "unicode": "U+1F1F0 U+1F1FC",
      "name": "Kuwait",
      "title": "flag for Kuwait",
      "name_ar": "الكويت"
    },
    {
      "code": "KG",
      "emoji": "🇰🇬",
      "unicode": "U+1F1F0 U+1F1EC",
      "name": "Kyrgyzstan",
      "title": "flag for Kyrgyzstan",
      "name_ar": "قرغيزستان"
    },
    {
      "code": "LV",
      "emoji": "🇱🇻",
      "unicode": "U+1F1F1 U+1F1FB",
      "name": "Latvia",
      "title": "flag for Latvia",
      "name_ar": "لاتفيا"
    },
    {
      "code": "LB",
      "emoji": "🇱🇧",
      "unicode": "U+1F1F1 U+1F1E7",
      "name": "Lebanon",
      "title": "flag for Lebanon",
      "name_ar": "لبنان"
    },
    {
      "code": "LS",
      "emoji": "🇱🇸",
      "unicode": "U+1F1F1 U+1F1F8",
      "name": "Lesotho",
      "title": "flag for Lesotho",
      "name_ar": "ليسوتو"
    },
    {
      "code": "LR",
      "emoji": "🇱🇷",
      "unicode": "U+1F1F1 U+1F1F7",
      "name": "Liberia",
      "title": "flag for Liberia",
      "name_ar": "ليبيريا"
    },
    {
      "code": "LY",
      "emoji": "🇱🇾",
      "unicode": "U+1F1F1 U+1F1FE",
      "name": "Libya",
      "title": "flag for Libya",
      "name_ar": "ليبيا"
    },
    {
      "code": "LI",
      "emoji": "🇱🇮",
      "unicode": "U+1F1F1 U+1F1EE",
      "name": "Liechtenstein",
      "title": "flag for Liechtenstein",
      "name_ar": "ليختنشتين"
    },
    {
      "code": "LT",
      "emoji": "🇱🇹",
      "unicode": "U+1F1F1 U+1F1F9",
      "name": "Lithuania",
      "title": "flag for Lithuania",
      "name_ar": "لتوانيا"
    },
    {
      "code": "LU",
      "emoji": "🇱🇺",
      "unicode": "U+1F1F1 U+1F1FA",
      "name": "Luxembourg",
      "title": "flag for Luxembourg",
      "name_ar": "لوكسمبورغ"
    },
    {
      "code": "MO",
      "emoji": "🇲🇴",
      "unicode": "U+1F1F2 U+1F1F4",
      "name": "Macao",
      "title": "flag for Macao",
      "name_ar": "ماكاو"
    },
    {
      "code": "MK",
      "emoji": "🇲🇰",
      "unicode": "U+1F1F2 U+1F1F0",
      "name": "Macedonia",
      "title": "flag for Macedonia",
      "name_ar": "جمهورية مقدونيا"
    },
    {
      "code": "MG",
      "emoji": "🇲🇬",
      "unicode": "U+1F1F2 U+1F1EC",
      "name": "Madagascar",
      "title": "flag for Madagascar",
      "name_ar": "مدغشقر"
    },
    {
      "code": "MW",
      "emoji": "🇲🇼",
      "unicode": "U+1F1F2 U+1F1FC",
      "name": "Malawi",
      "title": "flag for Malawi",
      "name_ar": "مالاوي"
    },
    {
      "code": "MY",
      "emoji": "🇲🇾",
      "unicode": "U+1F1F2 U+1F1FE",
      "name": "Malaysia",
      "title": "flag for Malaysia",
      "name_ar": "ماليزيا"
    },
    {
      "code": "MV",
      "emoji": "🇲🇻",
      "unicode": "U+1F1F2 U+1F1FB",
      "name": "Maldives",
      "title": "flag for Maldives",
      "name_ar": "جزر المالديف"
    },
    {
      "code": "ML",
      "emoji": "🇲🇱",
      "unicode": "U+1F1F2 U+1F1F1",
      "name": "Mali",
      "title": "flag for Mali",
      "name_ar": "مالي"
    },
    {
      "code": "MT",
      "emoji": "🇲🇹",
      "unicode": "U+1F1F2 U+1F1F9",
      "name": "Malta",
      "title": "flag for Malta",
      "name_ar": "مالطا"
    },
    {
      "code": "MH",
      "emoji": "🇲🇭",
      "unicode": "U+1F1F2 U+1F1ED",
      "name": "Marshall Islands",
      "title": "flag for Marshall Islands",
      "name_ar": "جزر مارشال"
    },
    {
      "code": "MQ",
      "emoji": "🇲🇶",
      "unicode": "U+1F1F2 U+1F1F6",
      "name": "Martinique",
      "title": "flag for Martinique",
      "name_ar": "مارتينيك"
    },
    {
      "code": "MR",
      "emoji": "🇲🇷",
      "unicode": "U+1F1F2 U+1F1F7",
      "name": "Mauritania",
      "title": "flag for Mauritania",
      "name_ar": "موريتانيا"
    },
    {
      "code": "MU",
      "emoji": "🇲🇺",
      "unicode": "U+1F1F2 U+1F1FA",
      "name": "Mauritius",
      "title": "flag for Mauritius",
      "name_ar": "موريشيوس"
    },
    {
      "code": "YT",
      "emoji": "🇾🇹",
      "unicode": "U+1F1FE U+1F1F9",
      "name": "Mayotte",
      "title": "flag for Mayotte",
      "name_ar": "مايوت"
    },
    {
      "code": "MX",
      "emoji": "🇲🇽",
      "unicode": "U+1F1F2 U+1F1FD",
      "name": "Mexico",
      "title": "flag for Mexico",
      "name_ar": "المكسيك"
    },
    {
      "code": "FM",
      "emoji": "🇫🇲",
      "unicode": "U+1F1EB U+1F1F2",
      "name": "Micronesia",
      "title": "flag for Micronesia",
      "name_ar": "ميكرونيزيا"
    },
    {
      "code": "MD",
      "emoji": "🇲🇩",
      "unicode": "U+1F1F2 U+1F1E9",
      "name": "Moldova",
      "title": "flag for Moldova",
      "name_ar": "مولدافيا"
    },
    {
      "code": "MC",
      "emoji": "🇲🇨",
      "unicode": "U+1F1F2 U+1F1E8",
      "name": "Monaco",
      "title": "flag for Monaco",
      "name_ar": "موناكو"
    },
    {
      "code": "MN",
      "emoji": "🇲🇳",
      "unicode": "U+1F1F2 U+1F1F3",
      "name": "Mongolia",
      "title": "flag for Mongolia",
      "name_ar": "منغوليا"
    },
    {
      "code": "ME",
      "emoji": "🇲🇪",
      "unicode": "U+1F1F2 U+1F1EA",
      "name": "Montenegro",
      "title": "flag for Montenegro",
      "name_ar": "الجبل الأسود"
    },
    {
      "code": "MS",
      "emoji": "🇲🇸",
      "unicode": "U+1F1F2 U+1F1F8",
      "name": "Montserrat",
      "title": "flag for Montserrat",
      "name_ar": "مونتسيرات"
    },
    {
      "code": "MA",
      "emoji": "🇲🇦",
      "unicode": "U+1F1F2 U+1F1E6",
      "name": "Morocco",
      "title": "flag for Morocco",
      "name_ar": "المغرب"
    },
    {
      "code": "MZ",
      "emoji": "🇲🇿",
      "unicode": "U+1F1F2 U+1F1FF",
      "name": "Mozambique",
      "title": "flag for Mozambique",
      "name_ar": "موزمبيق"
    },
    {
      "code": "MM",
      "emoji": "🇲🇲",
      "unicode": "U+1F1F2 U+1F1F2",
      "name": "Myanmar",
      "title": "flag for Myanmar",
      "name_ar": "ميانمار"
    },
    {
      "code": "NA",
      "emoji": "🇳🇦",
      "unicode": "U+1F1F3 U+1F1E6",
      "name": "Namibia",
      "title": "flag for Namibia",
      "name_ar": "ناميبيا"
    },
    {
      "code": "NR",
      "emoji": "🇳🇷",
      "unicode": "U+1F1F3 U+1F1F7",
      "name": "Nauru",
      "title": "flag for Nauru",
      "name_ar": "ناورو"
    },
    {
      "code": "NP",
      "emoji": "🇳🇵",
      "unicode": "U+1F1F3 U+1F1F5",
      "name": "Nepal",
      "title": "flag for Nepal",
      "name_ar": "نيبال"
    },
    {
      "code": "NL",
      "emoji": "🇳🇱",
      "unicode": "U+1F1F3 U+1F1F1",
      "name": "Netherlands",
      "title": "flag for Netherlands",
      "name_ar": "هولندا"
    },
    {
      "code": "NC",
      "emoji": "🇳🇨",
      "unicode": "U+1F1F3 U+1F1E8",
      "name": "New Caledonia",
      "title": "flag for New Caledonia",
      "name_ar": "كاليدونيا الجديدة"
    },
    {
      "code": "NZ",
      "emoji": "🇳🇿",
      "unicode": "U+1F1F3 U+1F1FF",
      "name": "New Zealand",
      "title": "flag for New Zealand",
      "name_ar": "نيوزيلندا"
    },
    {
      "code": "NI",
      "emoji": "🇳🇮",
      "unicode": "U+1F1F3 U+1F1EE",
      "name": "Nicaragua",
      "title": "flag for Nicaragua",
      "name_ar": "نيكاراغوا"
    },
    {
      "code": "NE",
      "emoji": "🇳🇪",
      "unicode": "U+1F1F3 U+1F1EA",
      "name": "Niger",
      "title": "flag for Niger",
      "name_ar": "النيجر"
    },
    {
      "code": "NG",
      "emoji": "🇳🇬",
      "unicode": "U+1F1F3 U+1F1EC",
      "name": "Nigeria",
      "title": "flag for Nigeria",
      "name_ar": "نيجيريا"
    },
    {
      "code": "NU",
      "emoji": "🇳🇺",
      "unicode": "U+1F1F3 U+1F1FA",
      "name": "Niue",
      "title": "flag for Niue",
      "name_ar": "نيوي"
    },
    {
      "code": "NF",
      "emoji": "🇳🇫",
      "unicode": "U+1F1F3 U+1F1EB",
      "name": "Norfolk Island",
      "title": "flag for Norfolk Island",
      "name_ar": "جزيرة نورفولك"
    },
    {
      "code": "KP",
      "emoji": "🇰🇵",
      "unicode": "U+1F1F0 U+1F1F5",
      "name": "North Korea",
      "title": "flag for North Korea",
      "name_ar": "كوريا"
    },
    {
      "code": "MP",
      "emoji": "🇲🇵",
      "unicode": "U+1F1F2 U+1F1F5",
      "name": "Northern Mariana Islands",
      "title": "flag for Northern Mariana Islands",
      "name_ar": "جزر مريانا الشمالية"
    },
    {
      "code": "NO",
      "emoji": "🇳🇴",
      "unicode": "U+1F1F3 U+1F1F4",
      "name": "Norway",
      "title": "flag for Norway",
      "name_ar": "النرويج"
    },
    {
      "code": "OM",
      "emoji": "🇴🇲",
      "unicode": "U+1F1F4 U+1F1F2",
      "name": "Oman",
      "title": "flag for Oman",
      "name_ar": "عمان"
    },
    {
      "code": "PK",
      "emoji": "🇵🇰",
      "unicode": "U+1F1F5 U+1F1F0",
      "name": "Pakistan",
      "title": "flag for Pakistan",
      "name_ar": "باكستان"
    },
    {
      "code": "PW",
      "emoji": "🇵🇼",
      "unicode": "U+1F1F5 U+1F1FC",
      "name": "Palau",
      "title": "flag for Palau",
      "name_ar": "بالاو"
    },
    {
      "code": "PS",
      "emoji": "🇵🇸",
      "unicode": "U+1F1F5 U+1F1F8",
      "name": "Palestine",
      "title": "flag for Palestine",
      "name_ar": "فلسطين"
    },
    {
      "code": "PA",
      "emoji": "🇵🇦",
      "unicode": "U+1F1F5 U+1F1E6",
      "name": "Panama",
      "title": "flag for Panama",
      "name_ar": "بناما"
    },
    {
      "code": "PG",
      "emoji": "🇵🇬",
      "unicode": "U+1F1F5 U+1F1EC",
      "name": "Papua New Guinea",
      "title": "flag for Papua New Guinea",
      "name_ar": "بابوا غينيا الجديدة"
    },
    {
      "code": "PY",
      "emoji": "🇵🇾",
      "unicode": "U+1F1F5 U+1F1FE",
      "name": "Paraguay",
      "title": "flag for Paraguay",
      "name_ar": "باراغواي"
    },
    {
      "code": "PE",
      "emoji": "🇵🇪",
      "unicode": "U+1F1F5 U+1F1EA",
      "name": "Peru",
      "title": "flag for Peru",
      "name_ar": "بيرو"
    },
    {
      "code": "PH",
      "emoji": "🇵🇭",
      "unicode": "U+1F1F5 U+1F1ED",
      "name": "Philippines",
      "title": "flag for Philippines",
      "name_ar": "الفليبين"
    },
    {
      "code": "PN",
      "emoji": "🇵🇳",
      "unicode": "U+1F1F5 U+1F1F3",
      "name": "Pitcairn",
      "title": "flag for Pitcairn",
      "name_ar": "بيتكيرن"
    },
    {
      "code": "PL",
      "emoji": "🇵🇱",
      "unicode": "U+1F1F5 U+1F1F1",
      "name": "Poland",
      "title": "flag for Poland",
      "name_ar": "بولندا"
    },
    {
      "code": "PT",
      "emoji": "🇵🇹",
      "unicode": "U+1F1F5 U+1F1F9",
      "name": "Portugal",
      "title": "flag for Portugal",
      "name_ar": "البرتغال"
    },
    {
      "code": "PR",
      "emoji": "🇵🇷",
      "unicode": "U+1F1F5 U+1F1F7",
      "name": "Puerto Rico",
      "title": "flag for Puerto Rico",
      "name_ar": "بورتوريكو"
    },
    {
      "code": "QA",
      "emoji": "🇶🇦",
      "unicode": "U+1F1F6 U+1F1E6",
      "name": "Qatar",
      "title": "flag for Qatar",
      "name_ar": "قطر"
    },
    {
      "code": "RO",
      "emoji": "🇷🇴",
      "unicode": "U+1F1F7 U+1F1F4",
      "name": "Romania",
      "title": "flag for Romania",
      "name_ar": "رومانيا"
    },
    {
      "code": "RU",
      "emoji": "🇷🇺",
      "unicode": "U+1F1F7 U+1F1FA",
      "name": "Russia",
      "title": "flag for Russia",
      "name_ar": "روس"
    },
    {
      "code": "RW",
      "emoji": "🇷🇼",
      "unicode": "U+1F1F7 U+1F1FC",
      "name": "Rwanda",
      "title": "flag for Rwanda",
      "name_ar": "رواندا"
    },
    {
      "code": "BL",
      "emoji": "🇧🇱",
      "unicode": "U+1F1E7 U+1F1F1",
      "name": "Saint Barthélemy",
      "title": "flag for Saint Barthélemy",
      "name_ar": "سانت بارتيليمي"
    },
    {
      "code": "SH",
      "emoji": "🇸🇭",
      "unicode": "U+1F1F8 U+1F1ED",
      "name": "Saint Helena, Ascension and Tristan Da Cunha",
      "title": "flag for Saint Helena, Ascension and Tristan Da Cunha",
      "name_ar": "سانت هيلانة ، أسنسيون وتريستان دا كونها"
    },
    {
      "code": "KN",
      "emoji": "🇰🇳",
      "unicode": "U+1F1F0 U+1F1F3",
      "name": "Saint Kitts and Nevis",
      "title": "flag for Saint Kitts and Nevis",
      "name_ar": "سانت كيتس ونيفيس"
    },
    {
      "code": "LC",
      "emoji": "🇱🇨",
      "unicode": "U+1F1F1 U+1F1E8",
      "name": "Saint Lucia",
      "title": "flag for Saint Lucia",
      "name_ar": "القديسة لوسيا"
    },
    {
      "code": "MF",
      "emoji": "🇲🇫",
      "unicode": "U+1F1F2 U+1F1EB",
      "name": "Saint Martin (French Part)",
      "title": "flag for Saint Martin (French Part)",
      "name_ar": "القديس مارتن"
    },
    {
      "code": "PM",
      "emoji": "🇵🇲",
      "unicode": "U+1F1F5 U+1F1F2",
      "name": "Saint Pierre and Miquelon",
      "title": "flag for Saint Pierre and Miquelon",
      "name_ar": "سانت بيير وميكلون"
    },
    {
      "code": "VC",
      "emoji": "🇻🇨",
      "unicode": "U+1F1FB U+1F1E8",
      "name": "Saint Vincent and The Grenadines",
      "title": "flag for Saint Vincent and The Grenadines",
      "name_ar": "سانت فنسنت وجزر غرينادين"
    },
    {
      "code": "WS",
      "emoji": "🇼🇸",
      "unicode": "U+1F1FC U+1F1F8",
      "name": "Samoa",
      "title": "flag for Samoa",
      "name_ar": "ساموا"
    },
    {
      "code": "SM",
      "emoji": "🇸🇲",
      "unicode": "U+1F1F8 U+1F1F2",
      "name": "San Marino",
      "title": "flag for San Marino",
      "name_ar": "سان مارينو"
    },
    {
      "code": "ST",
      "emoji": "🇸🇹",
      "unicode": "U+1F1F8 U+1F1F9",
      "name": "Sao Tome and Principe",
      "title": "flag for Sao Tome and Principe",
      "name_ar": "ساو تومي وبرنسيبي"
    },
    {
      "code": "SA",
      "emoji": "🇸🇦",
      "unicode": "U+1F1F8 U+1F1E6",
      "name": "Saudi Arabia",
      "title": "flag for Saudi Arabia",
      "name_ar": "السعودية"
    },
    {
      "code": "SN",
      "emoji": "🇸🇳",
      "unicode": "U+1F1F8 U+1F1F3",
      "name": "Senegal",
      "title": "flag for Senegal",
      "name_ar": "السنغال"
    },
    {
      "code": "RS",
      "emoji": "🇷🇸",
      "unicode": "U+1F1F7 U+1F1F8",
      "name": "Serbia",
      "title": "flag for Serbia",
      "name_ar": "صربيا"
    },
    {
      "code": "SC",
      "emoji": "🇸🇨",
      "unicode": "U+1F1F8 U+1F1E8",
      "name": "Seychelles",
      "title": "flag for Seychelles",
      "name_ar": "سيشيل"
    },
    {
      "code": "SL",
      "emoji": "🇸🇱",
      "unicode": "U+1F1F8 U+1F1F1",
      "name": "Sierra Leone",
      "title": "flag for Sierra Leone",
      "name_ar": "سيرا ليون"
    },
    {
      "code": "SG",
      "emoji": "🇸🇬",
      "unicode": "U+1F1F8 U+1F1EC",
      "name": "Singapore",
      "title": "flag for Singapore",
      "name_ar": "سنغافورة"
    },
    {
      "code": "SK",
      "emoji": "🇸🇰",
      "unicode": "U+1F1F8 U+1F1F0",
      "name": "Slovakia",
      "title": "flag for Slovakia",
      "name_ar": "سلوفاكيا"
    },
    {
      "code": "SI",
      "emoji": "🇸🇮",
      "unicode": "U+1F1F8 U+1F1EE",
      "name": "Slovenia",
      "title": "flag for Slovenia",
      "name_ar": "سلوفينيا"
    },
    {
      "code": "SB",
      "emoji": "🇸🇧",
      "unicode": "U+1F1F8 U+1F1E7",
      "name": "Solomon Islands",
      "title": "flag for Solomon Islands",
      "name_ar": "جزر سليمان"
    },
    {
      "code": "SO",
      "emoji": "🇸🇴",
      "unicode": "U+1F1F8 U+1F1F4",
      "name": "Somalia",
      "title": "flag for Somalia",
      "name_ar": "الصومال"
    },
    {
      "code": "ZA",
      "emoji": "🇿🇦",
      "unicode": "U+1F1FF U+1F1E6",
      "name": "South Africa",
      "title": "flag for South Africa",
      "name_ar": "جنوب أفريقيا"
    },
    {
      "code": "GS",
      "emoji": "🇬🇸",
      "unicode": "U+1F1EC U+1F1F8",
      "name": "South Georgia",
      "title": "flag for South Georgia",
      "name_ar": "جورجيا الجنوبية"
    },
    {
      "code": "KR",
      "emoji": "🇰🇷",
      "unicode": "U+1F1F0 U+1F1F7",
      "name": "South Korea",
      "title": "flag for South Korea",
      "name_ar": "كوريا الجنوبية"
    },
    {
      "code": "SS",
      "emoji": "🇸🇸",
      "unicode": "U+1F1F8 U+1F1F8",
      "name": "South Sudan",
      "title": "flag for South Sudan",
      "name_ar": "جنوب السودان"
    },
    {
      "code": "ES",
      "emoji": "🇪🇸",
      "unicode": "U+1F1EA U+1F1F8",
      "name": "Spain",
      "title": "flag for Spain",
      "name_ar": "إسبانيا"
    },
    {
      "code": "LK",
      "emoji": "🇱🇰",
      "unicode": "U+1F1F1 U+1F1F0",
      "name": "Sri Lanka",
      "title": "flag for Sri Lanka",
      "name_ar": "سريلانكا"
    },
    {
      "code": "SD",
      "emoji": "🇸🇩",
      "unicode": "U+1F1F8 U+1F1E9",
      "name": "Sudan",
      "title": "flag for Sudan",
      "name_ar": "سودان"
    },
    {
      "code": "SR",
      "emoji": "🇸🇷",
      "unicode": "U+1F1F8 U+1F1F7",
      "name": "Suriname",
      "title": "flag for Suriname",
      "name_ar": "سورينام"
    },
    {
      "code": "SJ",
      "emoji": "🇸🇯",
      "unicode": "U+1F1F8 U+1F1EF",
      "name": "Svalbard and Jan Mayen",
      "title": "flag for Svalbard and Jan Mayen",
      "name_ar": "سفالبارد وجان مايان"
    },
    {
      "code": "SZ",
      "emoji": "🇸🇿",
      "unicode": "U+1F1F8 U+1F1FF",
      "name": "Swaziland",
      "title": "flag for Swaziland",
      "name_ar": "سوازيلاند"
    },
    {
      "code": "SE",
      "emoji": "🇸🇪",
      "unicode": "U+1F1F8 U+1F1EA",
      "name": "Sweden",
      "title": "flag for Sweden",
      "name_ar": "السويد"
    },
    {
      "code": "CH",
      "emoji": "🇨🇭",
      "unicode": "U+1F1E8 U+1F1ED",
      "name": "Switzerland",
      "title": "flag for Switzerland",
      "name_ar": "سويسرا"
    },
    {
      "code": "SY",
      "emoji": "🇸🇾",
      "unicode": "U+1F1F8 U+1F1FE",
      "name": "Syrian Arab Republic",
      "title": "flag for Syrian Arab Republic",
      "name_ar": "الجمهورية العربية السورية"
    },
    {
      "code": "TW",
      "emoji": "🇹🇼",
      "unicode": "U+1F1F9 U+1F1FC",
      "name": "Taiwan",
      "title": "flag for Taiwan",
      "name_ar": "تايوان"
    },
    {
      "code": "TJ",
      "emoji": "🇹🇯",
      "unicode": "U+1F1F9 U+1F1EF",
      "name": "Tajikistan",
      "title": "flag for Tajikistan",
      "name_ar": "طاجيكستان"
    },
    {
      "code": "TZ",
      "emoji": "🇹🇿",
      "unicode": "U+1F1F9 U+1F1FF",
      "name": "Tanzania",
      "title": "flag for Tanzania",
      "name_ar": "تنزانيا"
    },
    {
      "code": "TH",
      "emoji": "🇹🇭",
      "unicode": "U+1F1F9 U+1F1ED",
      "name": "Thailand",
      "title": "flag for Thailand",
      "name_ar": "تايلندا"
    },
    {
      "code": "TL",
      "emoji": "🇹🇱",
      "unicode": "U+1F1F9 U+1F1F1",
      "name": "Timor-Leste",
      "title": "flag for Timor-Leste",
      "name_ar": "تيمور الشرقية"
    },
    {
      "code": "TK",
      "emoji": "🇹🇰",
      "unicode": "U+1F1F9 U+1F1F0",
      "name": "Tokelau",
      "title": "flag for Tokelau",
      "name_ar": "توكيلاو"
    },
    {
      "code": "TO",
      "emoji": "🇹🇴",
      "unicode": "U+1F1F9 U+1F1F4",
      "name": "Tonga",
      "title": "flag for Tonga",
      "name_ar": "تونغا"
    },
    {
      "code": "TT",
      "emoji": "🇹🇹",
      "unicode": "U+1F1F9 U+1F1F9",
      "name": "Trinidad and Tobago",
      "title": "flag for Trinidad and Tobago",
      "name_ar": "ترينداد وتوباغو"
    },
    {
      "code": "TN",
      "emoji": "🇹🇳",
      "unicode": "U+1F1F9 U+1F1F3",
      "name": "Tunisia",
      "title": "flag for Tunisia",
      "name_ar": "تونس"
    },
    {
      "code": "TR",
      "emoji": "🇹🇷",
      "unicode": "U+1F1F9 U+1F1F7",
      "name": "Turkey",
      "title": "flag for Turkey",
      "name_ar": "تركيا"
    },
    {
      "code": "TM",
      "emoji": "🇹🇲",
      "unicode": "U+1F1F9 U+1F1F2",
      "name": "Turkmenistan",
      "title": "flag for Turkmenistan",
      "name_ar": "تركمانستان"
    },
    {
      "code": "TC",
      "emoji": "🇹🇨",
      "unicode": "U+1F1F9 U+1F1E8",
      "name": "Turks and Caicos Islands",
      "title": "flag for Turks and Caicos Islands",
      "name_ar": "جزر تركس وكايكوس"
    },
    {
      "code": "TV",
      "emoji": "🇹🇻",
      "unicode": "U+1F1F9 U+1F1FB",
      "name": "Tuvalu",
      "title": "flag for Tuvalu",
      "name_ar": "توفالو"
    },
    {
      "code": "UG",
      "emoji": "🇺🇬",
      "unicode": "U+1F1FA U+1F1EC",
      "name": "Uganda",
      "title": "flag for Uganda",
      "name_ar": "أوغندا"
    },
    {
      "code": "UA",
      "emoji": "🇺🇦",
      "unicode": "U+1F1FA U+1F1E6",
      "name": "Ukraine",
      "title": "flag for Ukraine",
      "name_ar": "أوكرانيا"
    },
    {
      "code": "AE",
      "emoji": "🇦🇪",
      "unicode": "U+1F1E6 U+1F1EA",
      "name": "United Arab Emirates",
      "title": "flag for United Arab Emirates",
      "name_ar": "الإمارات"
    },
    {
      "code": "GB",
      "emoji": "🇬🇧",
      "unicode": "U+1F1EC U+1F1E7",
      "name": "United Kingdom",
      "title": "flag for United Kingdom",
      "name_ar": "المملكة المتحدة"
    },
    {
      "code": "US",
      "emoji": "🇺🇸",
      "unicode": "U+1F1FA U+1F1F8",
      "name": "United States",
      "title": "flag for United States",
      "name_ar": "الولايات المتحدة"
    },
    {
      "code": "UY",
      "emoji": "🇺🇾",
      "unicode": "U+1F1FA U+1F1FE",
      "name": "Uruguay",
      "title": "flag for Uruguay",
      "name_ar": "أوروغواي"
    },
    {
      "code": "UZ",
      "emoji": "🇺🇿",
      "unicode": "U+1F1FA U+1F1FF",
      "name": "Uzbekistan",
      "title": "flag for Uzbekistan",
      "name_ar": "أوزبكستان"
    },
    {
      "code": "VU",
      "emoji": "🇻🇺",
      "unicode": "U+1F1FB U+1F1FA",
      "name": "Vanuatu",
      "title": "flag for Vanuatu",
      "name_ar": "فانواتو"
    },
    {
      "code": "VA",
      "emoji": "🇻🇦",
      "unicode": "U+1F1FB U+1F1E6",
      "name": "Vatican City",
      "title": "flag for Vatican City",
      "name_ar": "مدينة الفاتيكان"
    },
    {
      "code": "VE",
      "emoji": "🇻🇪",
      "unicode": "U+1F1FB U+1F1EA",
      "name": "Venezuela",
      "title": "flag for Venezuela",
      "name_ar": "فنزويلا"
    },
    {
      "code": "VN",
      "emoji": "🇻🇳",
      "unicode": "U+1F1FB U+1F1F3",
      "name": "Viet Nam",
      "title": "flag for Viet Nam",
      "name_ar": "فيتنام"
    },
    {
      "code": "VG",
      "emoji": "🇻🇬",
      "unicode": "U+1F1FB U+1F1EC",
      "name": "Virgin Islands, British",
      "title": "flag for Virgin Islands, British",
      "name_ar": "جزر العذراء البريطانية"
    },
    {
      "code": "VI",
      "emoji": "🇻🇮",
      "unicode": "U+1F1FB U+1F1EE",
      "name": "Virgin Islands, U.S.",
      "title": "flag for Virgin Islands, U.S.",
      "name_ar": "جزر فيرجن ، الولايات المتحدة"
    },
    {
      "code": "WF",
      "emoji": "🇼🇫",
      "unicode": "U+1F1FC U+1F1EB",
      "name": "Wallis and Futuna",
      "title": "flag for Wallis and Futuna",
      "name_ar": "واليس وفوتونا"
    },
    {
      "code": "YE",
      "emoji": "🇾🇪",
      "unicode": "U+1F1FE U+1F1EA",
      "name": "Yemen",
      "title": "flag for Yemen",
      "name_ar": "اليمن"
    },
    {
      "code": "ZM",
      "emoji": "🇿🇲",
      "unicode": "U+1F1FF U+1F1F2",
      "name": "Zambia",
      "title": "flag for Zambia",
      "name_ar": "زامبيا"
    },
    {
      "code": "ZW",
      "emoji": "🇿🇼",
      "unicode": "U+1F1FF U+1F1FC",
      "name": "Zimbabwe",
      "title": "flag for Zimbabwe",
      "name_ar": "زيمبابوي"
    }
  ]
  


